/*!
 * Copyright (c) 2017-2018 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var env = require('../env');

var forge = require('node-forge');

var LinkedDataSignature = require('./LinkedDataSignature');

module.exports = /*#__PURE__*/function (_LinkedDataSignature) {
  _inherits(LinkedDataSignature2015, _LinkedDataSignature);

  /**
   * Advanced optional parameters and overrides:
   *
   * @param [domain] {string} domain to include in the signature.
   * @param [nonce] {string} nonce to include in the signature.
   * @param [useNativeCanonize] {boolean} true to use a native canonize
   *   algorithm.
   */
  function LinkedDataSignature2015() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$type = _ref.type,
        type = _ref$type === void 0 ? 'LinkedDataSignature2015' : _ref$type,
        privateKeyPem = _ref.privateKeyPem,
        publicKeyPem = _ref.publicKeyPem,
        creator = _ref.creator,
        date = _ref.date,
        domain = _ref.domain,
        nonce = _ref.nonce,
        useNativeCanonize = _ref.useNativeCanonize;

    _classCallCheck(this, LinkedDataSignature2015);

    if (domain !== undefined && typeof domain !== 'string') {
      throw new TypeError('"domain" must be a string.');
    }

    if (nonce !== undefined && typeof nonce !== 'string') {
      throw new TypeError('"nonce" must be a string.');
    }

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LinkedDataSignature2015).call(this, {
      type: type,
      creator: creator,
      date: date,
      domain: domain,
      nonce: nonce,
      useNativeCanonize: useNativeCanonize
    }));
    _this.legacy = true;
    _this.privateKeyPem = privateKeyPem;
    _this.publicKeyPem = publicKeyPem;
    _this.nonce = nonce;
    _this.domain = domain;
    return _this;
  }
  /**
   * @param document {object} to be signed.
   * @param purpose {ProofPurpose}
   * @param documentLoader {function}
   * @param expansionMap {function}
   * @param compactProof {boolean}
   *
   * @returns {Promise<object>} Resolves with the created proof object.
   */


  _createClass(LinkedDataSignature2015, [{
    key: "updateProof",
    value: function () {
      var _updateProof = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var proof;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                proof = _ref2.proof;

                if (this.domain !== undefined) {
                  proof.domain = this.domain;
                }

                if (this.nonce !== undefined) {
                  proof.nonce = this.nonce;
                }

                return _context.abrupt("return", proof);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateProof(_x) {
        return _updateProof.apply(this, arguments);
      }

      return updateProof;
    }()
    /**
     * @param proof {object} the proof to be verified.
     * @param document {object} the document the proof applies to.
     * @param purpose {ProofPurpose}
     * @param documentLoader {function}
     * @param expansionMap {function}
     * @param compactProof {boolean}
     *
     * @returns {Promise<{object}>} Resolves with the verification result.
     */

  }, {
    key: "verifyProof",
    value: function () {
      var _verifyProof = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
        var proof, document, purpose, documentLoader, expansionMap, compactProof;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                proof = _ref3.proof, document = _ref3.document, purpose = _ref3.purpose, documentLoader = _ref3.documentLoader, expansionMap = _ref3.expansionMap, compactProof = _ref3.compactProof;
                _context2.prev = 1;

                if (!(this.domain !== undefined && proof.domain !== this.domain)) {
                  _context2.next = 4;
                  break;
                }

                throw new Error('The domain is not as expected; ' + "domain=\"".concat(proof.domain, "\", expected=\"").concat(this.domain, "\""));

              case 4:
                return _context2.abrupt("return", _get(_getPrototypeOf(LinkedDataSignature2015.prototype), "verifyProof", this).call(this, {
                  proof: proof,
                  document: document,
                  purpose: purpose,
                  documentLoader: documentLoader,
                  expansionMap: expansionMap,
                  compactProof: compactProof
                }));

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](1);
                return _context2.abrupt("return", {
                  verified: false,
                  error: _context2.t0
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 7]]);
      }));

      function verifyProof(_x2) {
        return _verifyProof.apply(this, arguments);
      }

      return verifyProof;
    }()
    /**
     * @param document {object} to be signed/verified.
     * @param proof {object}
     * @param documentLoader {function}
     * @param expansionMap {function}
     * @param compactProof {boolean}
     *
     * @returns {Promise<{Uint8Array}>}.
     */

  }, {
    key: "createVerifyData",
    value: function () {
      var _createVerifyData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4) {
        var document, proof, documentLoader, expansionMap, c14n, verifyData, headers, keys, i, key, value, buffer;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                document = _ref4.document, proof = _ref4.proof, documentLoader = _ref4.documentLoader, expansionMap = _ref4.expansionMap;
                _context3.next = 3;
                return this.canonize(document, {
                  documentLoader: documentLoader,
                  expansionMap: expansionMap
                });

              case 3:
                c14n = _context3.sent;
                verifyData = '';
                headers = {
                  'http://purl.org/dc/elements/1.1/created': proof.created,
                  'https://w3id.org/security#domain': proof.domain,
                  'https://w3id.org/security#nonce': proof.nonce
                }; // add headers in lexicographical order

                keys = Object.keys(headers).sort();

                for (i = 0; i < keys.length; ++i) {
                  key = keys[i];
                  value = headers[key];

                  if (!(value === null || value === undefined)) {
                    verifyData += key + ': ' + value + '\n';
                  }
                }

                verifyData += c14n;
                buffer = new forge.util.ByteBuffer(verifyData, 'utf8');
                return _context3.abrupt("return", forge.util.binary.raw.decode(buffer.getBytes()));

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function createVerifyData(_x3) {
        return _createVerifyData.apply(this, arguments);
      }

      return createVerifyData;
    }()
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref5) {
        var verifyData, proof, privateKeyPem, signature, crypto, signer, privateKey, md;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                verifyData = _ref5.verifyData, proof = _ref5.proof;
                privateKeyPem = this.privateKeyPem;

                if (!(typeof privateKeyPem !== 'string')) {
                  _context4.next = 4;
                  break;
                }

                throw new TypeError('"privateKeyPem" must be a PEM formatted string.');

              case 4:
                if (env.nodejs) {
                  // optimize using node libraries
                  crypto = require('crypto');
                  signer = crypto.createSign('RSA-SHA256');
                  signer.update(Buffer.from(verifyData.buffer, verifyData.byteOffset, verifyData.length));
                  signature = signer.sign(privateKeyPem, 'base64');
                } else {
                  // browser or other environment
                  privateKey = forge.pki.privateKeyFromPem(privateKeyPem);
                  md = forge.md.sha256.create();
                  md.update(forge.util.binary.raw.encode(verifyData), 'binary');
                  signature = forge.util.encode64(privateKey.sign(md));
                }

                proof.signatureValue = signature;
                return _context4.abrupt("return", proof);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function sign(_x4) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }, {
    key: "verifySignature",
    value: function () {
      var _verifySignature = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref6) {
        var verifyData, proof, publicKeyPem, crypto, verifier, publicKey, md;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                verifyData = _ref6.verifyData, proof = _ref6.proof;
                publicKeyPem = this.publicKeyPem;

                if (!(typeof publicKeyPem !== 'string')) {
                  _context5.next = 4;
                  break;
                }

                throw new TypeError('Could not verify signature; invalid "publicKeyPem".');

              case 4:
                if (!env.nodejs) {
                  _context5.next = 9;
                  break;
                }

                // optimize using node libraries
                crypto = require('crypto');
                verifier = crypto.createVerify('RSA-SHA256');
                verifier.update(Buffer.from(verifyData.buffer, verifyData.byteOffset, verifyData.length));
                return _context5.abrupt("return", verifier.verify(publicKeyPem, proof.signatureValue, 'base64'));

              case 9:
                // browser or other environment
                publicKey = forge.pki.publicKeyFromPem(publicKeyPem);
                md = forge.md.sha256.create();
                md.update(forge.util.binary.raw.encode(verifyData), 'binary');
                _context5.prev = 12;
                return _context5.abrupt("return", publicKey.verify(md.digest().bytes(), forge.util.decode64(proof.signatureValue)));

              case 16:
                _context5.prev = 16;
                _context5.t0 = _context5["catch"](12);
                return _context5.abrupt("return", false);

              case 19:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[12, 16]]);
      }));

      function verifySignature(_x5) {
        return _verifySignature.apply(this, arguments);
      }

      return verifySignature;
    }()
  }, {
    key: "getVerificationMethod",
    value: function () {
      var _getVerificationMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref7) {
        var proof, documentLoader, verificationMethod;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                proof = _ref7.proof, documentLoader = _ref7.documentLoader;
                _context6.next = 3;
                return _get(_getPrototypeOf(LinkedDataSignature2015.prototype), "getVerificationMethod", this).call(this, {
                  proof: proof,
                  documentLoader: documentLoader
                });

              case 3:
                verificationMethod = _context6.sent;

                if (!this.publicKeyPem) {
                  this.publicKeyPem = verificationMethod.publicKeyPem;
                }

                return _context6.abrupt("return", verificationMethod);

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getVerificationMethod(_x6) {
        return _getVerificationMethod.apply(this, arguments);
      }

      return getVerificationMethod;
    }()
  }]);

  return LinkedDataSignature2015;
}(LinkedDataSignature);